import AutoSubmit from '@stimulus-components/auto-submit';

import { registerControllers } from 'stimulus-vite-helpers';
import { stimulus } from '~/init/stimulus.js';

const controllers = import.meta.glob('~/controllers/**/*_controller.js', { eager: true });
const components = import.meta.glob('../../components/**/*.{js,css}', { eager: true });

stimulus.register('auto-submit', AutoSubmit);

registerControllers(stimulus, controllers);
registerControllers(stimulus, components);
